import React, { useState, useEffect, useContext, Component } from 'react';
import { Link, useNavigate, useLocation, useParams } from 'react-router-dom'

import AccountSidebar from '../../components/AccountSidebar';
import { toast } from 'react-hot-toast';
import { useDispatch } from 'react-redux';
import { authActions } from '../../../redux/store';
import axios from 'axios';
import axiosInstance, { weburl } from '../../../axiosInstance';
import Header from '../../components/Header';
import Footer from '../../components/Footer';

 
import jsPDF from 'jspdf';

import html2canvas from 'html2canvas';
import { Helmet } from 'react-helmet';
import { useBlogContext } from '../../../fetchdata/BlogContext';
import getCookie from '../../../helper/getCookie';
import getDecryptData from '../../../helper/getDecryptData';
import HeaderPage from '../../components/HeaderPage';
import LoadingScreen from '../../components/LoadingScreen';

const CryptoJS = window.CryptoJS;


const AccountOrderView = () => {


   

  const { Headers , isHeader} = useBlogContext();

  const [reason, setReason] = useState('');

  const handleReasonChange = (event) => {
    setReason(event.target.value);
  };

  function decrypt(encryptedText, key) {
    const keyHex = CryptoJS.enc.Hex.parse(md5(key));
    const initVector = CryptoJS.enc.Hex.parse('000102030405060708090a0b0c0d0e0f');
    const encryptedHex = CryptoJS.enc.Hex.parse(encryptedText);
    const decryptedText = CryptoJS.AES.decrypt(
        { ciphertext: encryptedHex },
        keyHex,
        { iv: initVector, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.NoPadding }
    );
    return decryptedText.toString(CryptoJS.enc.Utf8);
}

function md5(input) {
    return CryptoJS.MD5(input).toString(CryptoJS.enc.Hex);
}


  async function makeRequest() {
console.log('stats')
    try {
      const response = await axiosInstance.get(`/update-stuck-order/${Order.orderId}`);
      console.log(response.data)


    } catch (error) {
      console.error('Error:', error);
    }
  }



  const [formData, setFormData] = useState({
    reason: "",
    comment: "",
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: type === 'checkbox' ? checked : value }));
  };


  const { orderId ,userId} = useParams();

 // const userId = localStorage.getItem('userId');
      const decryptdatajson =  getDecryptData();

  // const userId = decryptdatajson._id;


  const navigate = useNavigate();
  const dispatch = useDispatch();

  // const isLoginFromLocalStorage = localStorage.getItem('token') ? true : false;
  const isLoginFromLocalStorage =  getCookie('token') ? true : false;

  const [isLogin, setIsLogin] = useState(isLoginFromLocalStorage);

  const [isLoginForm, setIsLoginForm] = useState(true); // State to manage which form to display

  const [IfLogin, setIfLogin] = useState(true); // State to manage which form to display



  const toggleForm = () => {
    setIsLoginForm(prevState => !prevState); // Toggle between login and signup forms
  };


  // useEffect(() => {
  //   console.log(isLoginFromLocalStorage, 'isLoginFromLocalStorage')

  //   const checkUserToken = async () => {
  //     console.log('Effect is running');
  //     // Check if this is printed multiple times
  //    // const usertoken = localStorage.getItem('token');
  //     const usertoken =  getCookie('token');
  //     if (!usertoken) {
  //       toast.error("Please Login First");
  //       navigate('/');

  //     }

  //   }
  //   checkUserToken();
  // }, [dispatch, navigate]);




  const [Order, setOrder] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [OrderPlace, setOrderPlace] = useState('');
  const [MYuser, setMYuser] = useState(false);



  const saveAsPDF = async () => {
    const printContent = document.getElementById('print');

    // Set the scale factor for better quality
    const scale = 5;

    // Set the quality of the JPEG image
    const imageQuality = 1; // 1 is maximum quality

    // Convert print content to image with higher scale
    html2canvas(printContent, {
      scale: scale,
      useCORS: true, // Enable CORS to support loading images from different origins
      logging: true // Enable logging for debugging
    }).then(canvas => {
      const imgData = canvas.toDataURL('image/jpeg', imageQuality); // Use JPEG format with specified quality

      // Calculate dimensions of PDF page
      const pdfWidth = 297; // A4 width in mm
      const pdfHeight = 210; // A4 height in mm
      const ratio = canvas.width / canvas.height;

      let pdfHeightAdjusted = pdfHeight;
      let pdfWidthAdjusted = pdfWidth;

      if (ratio < pdfWidth / pdfHeight) {
        pdfWidthAdjusted = pdfHeight * ratio;
      } else {
        pdfHeightAdjusted = pdfWidth / ratio;
      }

      // Calculate center position for the image
      const xPos = (pdfWidth - pdfWidthAdjusted) / 2;
      const yPos = (pdfHeight - pdfHeightAdjusted) / 2;

      // Create a new jsPDF instance
      const pdf = new jsPDF({
        orientation: 'landscape', // Set the orientation of the PDF to landscape
        unit: 'mm', // Use millimeters as the unit for measurements
        format: [pdfWidth, pdfHeight] // Set the format of the PDF (A4 size)
      });

      // Add image to PDF document at the calculated center position
      pdf.addImage(imgData, 'JPEG', xPos, yPos, pdfWidthAdjusted, pdfHeightAdjusted);

      // Save the PDF
      pdf.save("invoice.pdf");
    });
  }

  const getUserOrders = async () => {

    try {
      // const id = localStorage.getItem('userId');
      const { data } = await axiosInstance.get(`/user-orders-view/${userId}/${orderId}`);

      if (data?.success) {
        console.log('order', data)
        setOrder(data?.userOrder);

      }

      console.log(data)
      
      if(data.userOrder.mode === "CCAvenue" && data.userOrder.payment === 2 ){
        setTimeout(function() {  
             window.location.reload();
         }, 1000);

        try {
          const response = await axiosInstance.get(`/update-stuck-order/${data.userOrder.orderId}`);
          console.log(response.data)
    
    
        } catch (error) {
          console.error('Error:', error);
        }
        
      }
      if( data.userOrder.mode === "CCAvenue" && data.userOrder.payment === 0 && data.userOrder.status === "1"){

        setTimeout(function() {  
          window.location.reload();
      }, 1000);

                try {
                  const response = await axiosInstance.get(`/update-stuck-order/${data.userOrder.orderId}`);
                  console.log(response.data)
            
            
                } catch (error) {
                  console.error('Error:', error);
                }
                
              }

      setIsLoading(false); // Set loading state to false after fetching data
      setIfLogin(false)
    } catch (error) {
      console.log(error);
      setIsLoading(false); // Set loading state to false in case of an error
      toast.error("order Not found");
      navigate('/account');
    }
  };

  const [showModal, setShowModal] = useState(false);

  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);


  function formatDate(dateString) {
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-US', options);
  }

  const toNumber = (value) => {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : 0;
  };

  const chargeFields = [
    "bookingCharges",
    "nightCharges",
    "mealCharges",
    "conveyanceCharges",
  ];

  const getOrderChargeValue = (orderData = Order, field) => {
    if (field === "nightCharges") {
      return toNumber(orderData?.nightCharges ?? orderData?.items?.[0]?.NightCharges);
    }

    if (field === "mealCharges") {
      return toNumber(orderData?.mealCharges ?? orderData?.foodCharges);
    }

    return toNumber(orderData?.[field]);
  };

  const calculateNightChargeTotal = (orderData = Order) =>
    getOrderChargeValue(orderData, "nightCharges") * toNumber(orderData?.nightDays);

  const formatOrderAmount = (value) => {
    const amount = toNumber(value);
    return Number.isInteger(amount) ? String(amount) : amount.toFixed(2);
  };

  const calculateItemsSubtotal = (orderItems = []) =>
    orderItems.reduce((total, item) => {
      const quantity = toNumber(item.quantity) || 1;
      return total + quantity * toNumber(item.price);
    }, 0);

  const calculateChargesTotal = (orderData = Order) =>
    chargeFields.reduce(
      (total, field) =>
        total +
        (field === "nightCharges"
          ? calculateNightChargeTotal(orderData)
          : getOrderChargeValue(orderData, field)),
      0
    );

  const calculateOrderTaxAmount = (orderData = Order) => {
    const savedGst = toNumber(orderData?.driverCommissionGST);
    if (savedGst > 0) return savedGst;

    const savedCommission = toNumber(orderData?.driverCommissionAmount);
    if (savedCommission > 0) {
      return savedCommission - savedCommission / 1.18;
    }

    const percent = toNumber(orderData?.driverCommissionPercent);
    if (!percent) return 0;

    const subtotal = calculateItemsSubtotal(orderData.items || []);
    const commissionBase = Math.max(
      0,
      subtotal -
        getOrderChargeValue(orderData, "mealCharges") -
        getOrderChargeValue(orderData, "conveyanceCharges") +
        toNumber(orderData?.discount)
    );
    return (commissionBase * percent * 18) / 10000;
  };

  const calculateOrderTotal = (orderData = {}, forceIncludeCharges = false) => {
    const itemsSubtotal = calculateItemsSubtotal(orderData.items || []);
    const discountAmount = Math.abs(toNumber(orderData.discount));
    const savedTotal = Number(orderData.totalAmount);

    if (!forceIncludeCharges && Number.isFinite(savedTotal)) {
      return Math.max(0, savedTotal);
    }

    return Math.max(
      0,
      itemsSubtotal +
        calculateChargesTotal(orderData) -
        discountAmount +
        calculateOrderTaxAmount(orderData)
    );
  };


  useEffect(() => {

    // if (!IfLogin) {
    //   const getUsernameAndEmailFromLocalStorage = () => {
    //     // const userString = localStorage.getItem('user');
    //     const userString = getCookie('user');

    //     if (userString) {
    //       const { username, email } = JSON.parse(userString);
    //       return { username, email };
    //     }
    //     return null;
    //   };

    //   // Retrieve username and email from local storage user data
    //   const { username, email } = getUsernameAndEmailFromLocalStorage();
    //   setMYuser(username);
    // }

    getUserOrders();
  }, []); // Empty dependency array ensures that the effect runs once after the initial render

  const [loading, setLoading] = useState(true);


  const CancelStatusChange = async (event) => {
    const newStatus = event.target.value;
    setLoading(true);

    try {
      await axiosInstance.put(`/cancel-order/${orderId}`, formData);
      setLoading(false);
      getUserOrders();
      toast.success("Order Cancel success!");
      window.location.reload();

    } catch (error) {
      console.error('Error Order Cancel:', error);
      setLoading(false);
    }

  };


    
    const downloadInvoice = async (id) => {
         try {
            const response = 
                await toast.promise(
                    axiosInstance.post(
                        `/download-invoice-order`, { invoiceId : id},
                        { responseType: 'blob' }
                    ),
                    {
                        loading: 'Invoice Downloading...',
                        success: 'Invoice Downloaded!',
                        error: 'Failed to Download Invoice.'
                    }
                );

            // await axiosInstance.get(`/admin/export/alltrans/`, { responseType: 'blob' });
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'invoice.pdf');
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
        } catch (error) {
            console.error('Error exporting data:', error);
            toast.error('Error exporting data:', error);
        }

    };
    


  const orderItems = Array.isArray(Order?.items) ? Order.items : [];
  const orderSubtotal = calculateItemsSubtotal(orderItems);
  const orderDiscount = Math.abs(toNumber(Order?.discount));
  const orderTaxAmount = calculateOrderTaxAmount(Order);
  const orderTotal = calculateOrderTotal(Order);
  const orderPaid = toNumber(Order?.paid);
  const orderBalance = Math.max(0, orderTotal - orderPaid);
  const orderChargeRows = [
    ["bookingCharges", "Booking Charges", getOrderChargeValue(Order, "bookingCharges")],
    ["nightCharges", "Night Charges", getOrderChargeValue(Order, "nightCharges")],
    ["mealCharges", "Meal Charges", getOrderChargeValue(Order, "mealCharges")],
    ["conveyanceCharges", "Conveyance Charges", getOrderChargeValue(Order, "conveyanceCharges")],
  ];
  const hasDayLogic = orderItems.some((item) => String(item.logic) === '1');
  const hasDistanceLogic = orderItems.some((item) => String(item.logic) === '2');
  const showPerMinuteColumn = !hasDayLogic && !hasDistanceLogic;
  const getLogicLabel = (logic) => {
    if (String(logic) === '1') return 'Day Logic';
    if (String(logic) === '2') return 'Distance Logic';
    return 'NO Logic';
  };
  const getItemTotal = (item) => (toNumber(item.quantity) || 1) * toNumber(item.price);

  return (
    <>

     
     
       
      <HeaderPage title={`Order ID #${Order?.orderId ?? ''}`} />
    
      <main className="page-content bg-white space-top  mypadding overflow-auto pb-4 px-0" >
  <div id="main-content" className="bg-white px-3 rounded">
                  


    {isLoading ?  <div>
            <div className="border bg-white rounded mx-auto ">
        <div className="card-body p-2">

          {/* Header */}
          <div className="d-flex justify-content-between align-items-center mb-3">
            <div className="d-flex align-items-center">
              <div
                className="skeleton rounded-circle me-3"
                style={{ width: 45, height: 45 }}
              />
              <div>
                <div className="skeleton mb-2" style={{ width: 160, height: 14, borderRadius: 8 }} />
                <div className="skeleton" style={{ width: 220, height: 12, borderRadius: 8 }} />
              </div>
            </div>
          </div>

          <hr className="my-3" />

          {/* Invoice Dates */}
          <div className="d-flex text-center mb-3">
            <div className="col-6 bg-light rounded-3 py-2 me-1 border">
              <div className="skeleton mx-auto mb-2" style={{ width: 90, height: 10, borderRadius: 8 }} />
              <div className="skeleton mx-auto" style={{ width: 120, height: 14, borderRadius: 8 }} />
            </div>

            <div className="col bg-light rounded-3 py-2 ms-1 border">
              <div className="skeleton mx-auto mb-2" style={{ width: 110, height: 10, borderRadius: 8 }} />
              <div className="skeleton mx-auto" style={{ width: 70, height: 22, borderRadius: 20 }} />
            </div>
          </div>

          {/* Item Details */}
          <div className="d-flex justify-content-between align-items-center mb-2">
            <div className="skeleton" style={{ width: 110, height: 14, borderRadius: 8 }} />
            <div className="skeleton" style={{ width: 70, height: 22, borderRadius: 20 }} />
          </div>

          {/* Item List */}
          <div className="list-group rounded-4 mb-3">

            {Array.from({ length: 2 }).map((_, i) => (
              <div key={i} className="list-group-item border-0 rounded-0 border-bottom d-flex justify-content-between align-items-start">
                <div className="d-flex align-items-start">
                  <div
                    className="skeleton rounded me-3"
                    style={{ width: 40, height: 40, borderRadius: 8 }}
                  />
                  <div>
                    <div className="skeleton mb-2" style={{ width: 200, height: 14, borderRadius: 8 }} />
                    <div className="skeleton mb-2" style={{ width: 130, height: 12, borderRadius: 8 }} />
                    <div className="skeleton mb-2" style={{ width: 170, height: 12, borderRadius: 8 }} />
                    <div className="skeleton" style={{ width: 220, height: 12, borderRadius: 8 }} />
                  </div>
                </div>

                <div className="skeleton" style={{ width: 60, height: 14, borderRadius: 8, marginTop: 4 }} />
              </div>
            ))}

          </div>

          {/* Summary */}
          <div className="p-3 bg-light rounded-3 border">
            <div className="skeleton mb-3" style={{ width: 120, height: 14, borderRadius: 8 }} />

            <div className="d-flex justify-content-between mb-2">
              <div className="skeleton" style={{ width: 80, height: 12, borderRadius: 8 }} />
              <div className="skeleton" style={{ width: 70, height: 12, borderRadius: 8 }} />
            </div>

            <div className="d-flex justify-content-between mb-2">
              <div className="skeleton" style={{ width: 80, height: 12, borderRadius: 8 }} />
              <div className="skeleton" style={{ width: 70, height: 12, borderRadius: 8 }} />
            </div>

            <div className="d-flex justify-content-between mb-2">
              <div className="skeleton" style={{ width: 110, height: 12, borderRadius: 8 }} />
              <div className="skeleton" style={{ width: 90, height: 12, borderRadius: 8 }} />
            </div>

            <hr className="my-2" />

            <div className="d-flex justify-content-between align-items-center">
              <div className="skeleton" style={{ width: 60, height: 14, borderRadius: 8 }} />
              <div className="skeleton" style={{ width: 90, height: 16, borderRadius: 8 }} />
            </div>
          </div>

        </div>
      </div>

   
      {/* Invoice button skeleton */}
      <div className="skeleton mt-4" style={{ width: "100%", height: 44, borderRadius: 10 }} />
    
      </div> :
                    (<>


<div   className=" border bg-white rounded mx-auto "

              >
                <div className="card-body p-2">
                  {/* Header */}
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <div className="d-flex align-items-center">
                      <div
                        className="bg-dark text-white rounded-circle d-flex justify-content-center align-items-center me-3 shadow-sm"
                        style={{ width: 45, height: 45 }}
                      >
                        <strong>{Order.details[0]?.username
  ?.split(' ')
  .slice(0, 2)
  .map(word => word[0])
  .join('')
  .toUpperCase()}

</strong>
                      </div>
                      <div>
                        <h6 className="mb-0 fw-semibold"> {Order.details[0].username} </h6>
                        <small className="text-muted"> {Order.details[0].email} </small>
                      </div>
                    </div>
                    {/* <a href="#" className="text-decoration-none text-primary small fw-medium">
                      Change
                    </a> */}
                  </div>
                  <hr className="my-3" />
                  {/* Invoice Dates */}
                  <div className="d-flex text-center mb-3">
                    <div className="col-6 bg-light rounded-3 py-2 me-1 border">
                      <small className="text-muted d-block">Invoice Date</small>
                      <span className="fw-semibold">  {formatDate(Order.createdAt)}  </span>
                    </div>
                    <div className="col bg-light rounded-3 py-2 ms-1 border">
                      <small className="text-muted d-block">Payment Status</small>
                <span
  className={`text-white px-2 rounded ${
    Order.payment === 0
      ? "bg-danger"
      : Order.payment === 1
      ? "bg-success"
      : "bg-warning"
  }`}
>
  {Order.payment === 0
    ? "Unpaid"
    : Order.payment === 1
    ? "Paid"
    : "Failed"}
</span>

{orderBalance > 0 && (
  <span className="text-danger ms-2">
    Unpaid ₹{formatOrderAmount(orderBalance)}
  </span>
)}
                    </div>
                  </div>

                  {/* Item Details */}
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <h6 className="text-dark fw-semibold mb-0">Item Details</h6>
                    <span className="badge bg-primary-subtle text-primary">
                      {orderItems.length} {orderItems.length > 1 ? 'items' : 'item'}
                    </span>
                  </div>

                  {/* Item List */}
                  <div className="list-group rounded-4 mb-3">
                    {orderItems.map((Pro) => (
                      <div>

                      <div
                        key={Pro.id}
                        className="list-group-item border-0 rounded-0 border-bottom d-flex justify-content-between align-items-center"
                      >
                        <div className="d-flex align-items-center">
                          
                          <img
                            src={  Pro?.image}
                            alt={Pro.title}
                            width={40}
                            className="rounded me-3"
                            style={{ aspectRatio: '1/1', objectFit: 'cover' }}
                            data-bs-toggle="modal" data-bs-target="#exampleModal"
                          />
                          <div>
                            <strong>{Pro.title}</strong>
                            
                            <div>
                              <small className="text-muted">
                                {Pro.quantity} × ₹{formatOrderAmount(Pro.price)}
                              </small>
                            </div>
                            <div className="small text-muted">
                              <span>Logic: {getLogicLabel(Pro.logic)}</span>
                            </div>
                            {showPerMinuteColumn && (
                              <div className="small text-muted">
                                Per minute price: ₹{formatOrderAmount(Pro.minPrice)}
                              </div>
                            )}
                            {hasDayLogic && String(Pro.logic) === '1' && (
                              <div className="small text-muted">
                                Full Day: {formatOrderAmount(Pro.fullday ?? Pro.day)}
                              </div>
                            )}
                            {hasDistanceLogic && String(Pro.logic) === '2' && (
                              <div className="small text-muted">
                                Per km price: ₹{formatOrderAmount(Pro.kmCharges)}
                              </div>
                            )}
{Pro?.addOns !== 1 &&  <>
<div className="fs-sm small"> 
                               <span className="text-body-secondary">Date: </span>
                               <span className="text-body-secondary">  {Pro?.date ? new Date(Pro.date).toLocaleDateString('en-US', {
       weekday: 'short',
       day: '2-digit',
       month: 'short'
     }) : 'NA'} </span>
                             </div>

<div className="small"> 
                               <span className="text-body-secondary">Time: </span>
                               <span className="text-body-secondary">{Pro?.time || 'NA'} / {Pro.hour + ' Hour' || 'NA'}</span>
                          
                             </div>
             
</>}
                          

                          </div>
                        </div>
                        <span className="fw-semibold">
                          ₹{formatOrderAmount(getItemTotal(Pro))}
                        </span>
                      </div>

                      {Pro?.addOns !== 1 &&  <>
 <br/>
                 <div className="text-body-secondary"> <b className='fw-bold text-black'> Pickup :  </b>{Pro?.pickup || 'NA'}  </div>
                 <div className="text-body-secondary"> <b className='fw-bold text-black'>  Dropoff : </b> {Pro?.dropoff || 'NA'}  </div>

</>}
              

                         </div>
                    ))}
                  </div>

                  {/* Summary */}
                  <div className="p-3 bg-light rounded-3 border">
                    <h6 className="text-dark fw-semibold mb-3">Total Summary</h6>

                    <div className="d-flex justify-content-between mb-2">
                      <span className="text-muted">Subtotal</span>
                      <span className="fw-semibold">₹{formatOrderAmount(orderSubtotal)}</span>
                    </div>

                    <div className="d-flex justify-content-between mb-2">
                      <span className="text-muted">Discount</span>
                      <span className="fw-semibold text-danger">
                        {orderDiscount > 0 ? `- ₹${formatOrderAmount(orderDiscount)}` : '₹0'}
                      </span>
                    </div>

                    {orderChargeRows
                      .map(([field, label, value]) => (
                        <div className="d-flex justify-content-between mb-2" key={field}>
                          <span className="text-muted">{label}</span>
                          <span className="fw-semibold text-end">
                            ₹{formatOrderAmount(value)}
                            {field === "nightCharges" && (
                              <small className="d-block text-muted fw-normal">
                                × {Order?.nightDays || 0} Day{toNumber(Order?.nightDays) > 1 ? "s" : ""} = ₹{formatOrderAmount(calculateNightChargeTotal(Order))}
                              </small>
                            )}
                          </span>
                        </div>
                      ))}

                    <div className="d-flex justify-content-between mb-2">
                      <span className="text-muted">Platform Charges</span>
                      <span className="fw-semibold">₹{formatOrderAmount(orderTaxAmount)}</span>
                    </div>

                    <hr className="my-2" />

                    {/* Grand Total */}
                    <div className="d-flex justify-content-between align-items-center">
                      <h6 className="fw-bold mb-0">Total</h6>
                      <h5 className="fw-bold text-primary mb-0">₹{formatOrderAmount(orderTotal)}</h5>
                    </div>
                  </div>


                </div>
               </div>

                     

                      {['1', '2', '3'].includes(Order.status) && (
                        <>

                          <div className="d-flex">
                            <button data-bs-toggle="modal" data-bs-target="#cancel" className="btn btn-danger py-1">
                              <i className="bi bi-exclamation-circle me-2"></i>
                              <span className="text">Cancel</span>
                            </button>
                          </div>


                          <div
                            className="modal fade"
                            id="cancel"
                            tabIndex={-1}
                            aria-labelledby="exampleModalLabel"
                            aria-hidden="true"
                          >
                            <div className="modal-dialog">
                              <div className="modal-content">
                                <div className="modal-header">
                                  <h5 className="modal-title" id="exampleModalLabel">
                                    Cancellation Reason
                                  </h5>
                                  <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                  />
                                </div>
                                <div className="modal-body">

                                  <div className="form-check">
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      id="outOfStock"
                                      name="reason"
                                      value="Item out of stock"
                                      checked={formData.reason === 'Item out of stock'}
                                      onChange={handleChange}
                                    />
                                    <label className="form-check-label" htmlFor="outOfStock">
                                      Item out of stock
                                    </label>
                                  </div>
                                  <div className="form-check">
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      id="changedMind"
                                      name="reason"
                                      value="Changed my mind"
                                      checked={formData.reason === 'Changed my mind'}
                                      onChange={handleChange}
                                    />
                                    <label className="form-check-label" htmlFor="changedMind">
                                      Changed my mind
                                    </label>
                                  </div>
                                  <div className="form-check">
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      id="betterDealElsewhere"
                                      name="reason"
                                      value="Found a better deal elsewhere"
                                      checked={formData.reason === 'Found a better deal elsewhere'}
                                      onChange={handleChange}
                                    />
                                    <label className="form-check-label" htmlFor="betterDealElsewhere">
                                      Found a better deal elsewhere
                                    </label>
                                  </div>
                                  <div className="form-check">
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      id="deliveryDelay"
                                      name="reason"
                                      value="Delivery delay"
                                      checked={formData.reason === 'Delivery delay'}
                                      onChange={handleChange}
                                    />
                                    <label className="form-check-label" htmlFor="deliveryDelay">
                                      Delivery delay
                                    </label>
                                  </div>
                                  <div className="form-check">
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      id="productIssue"
                                      name="reason"
                                      value="Product issue"
                                      checked={formData.reason === 'Product issue'}
                                      onChange={handleChange}
                                    />
                                    <label className="form-check-label" htmlFor="productIssue">
                                      Product issue
                                    </label>
                                  </div>
                                  <div className="form-check">
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      id="incorrectItem"
                                      name="reason"
                                      value="Received incorrect item"
                                      checked={formData.reason === 'Received incorrect item'}
                                      onChange={handleChange}
                                    />
                                    <label className="form-check-label" htmlFor="incorrectItem">
                                      Received incorrect item
                                    </label>
                                  </div>
                                  <div className="form-check">
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      id="other1"
                                      name="reason"
                                      value="Other"
                                      checked={formData.reason === 'Other'}
                                      onChange={handleChange}
                                    />
                                    <label className="form-check-label" htmlFor="other1">
                                      Other
                                    </label>
                                  </div>

                                  <div className="mb-3 mt-3">
                                    <label htmlFor="exampleFormControlTextarea1" className="form-label">
                                      Comment <span className='text-danger'> * </span>
                                    </label>
                                    <textarea
                                      className="form-control"
                                      id="comment"
                                      name="comment"
                                      rows={3}
                                      value={formData.comment}
                                      onChange={handleChange}
                                    />
                                  </div>




                                </div>
                                <div className="modal-footer">
                                  <button
                                    type="button"
                                    className="btn btn-secondary"
                                    data-bs-dismiss="modal"
                                  >
                                    Close
                                  </button>

                                  <button onClick={CancelStatusChange} type="button" className="btn btn-danger" disabled={formData.comment === '' && formData.reason === ''}>
                                    Cancel Order
                                  </button>

                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      )}



       <button 
                      // onClick={saveAsPDF}
                     onClick={() => downloadInvoice(Order._id)}
                       className="btn btn-primary mt-4 w-100 rounded btn-md">
                  
                       <i class="ri-file-pdf-2-fill fw-light me-2"></i>  <span className="text"> Invoice</span>
                      </button>


                    </>)}

 


                </div>
</main>

            
 


    </>
  )
}

export default AccountOrderView
